export enum ViewMode {
  Started = 'started',
  Completed = 'completed',
}

export enum ProgressStatus {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
}

export type ProgressStatusType = `${ProgressStatus}`;